import React, { useState } from 'react';
import { Field, FieldProps } from 'formik';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment, { Moment } from 'moment';

interface Props {
  label: string;
  name: string;
  placeholder: string;
  isRequired: boolean;
  errorMessage: string;
  onChange: (field: any) => void;
  formField: any;
}

const DateField: React.FC<Props> = ({
  label,
  name,
  placeholder,
  isRequired,
  errorMessage,
  onChange,
  formField,
}) => {
  const [open, setOpen] = useState(false);

  const handleDateChange = (date: Moment | null, form: any) => {
    if (date && date.isValid()) {
      const formattedDate = date.format('YYYY-MM-DD');
      form.setFieldValue(name, formattedDate);
      onChange({ ...formField, value: formattedDate });
    } else {
      form.setFieldValue(name, ''); // Handle invalid or null date
    }
  };

  return (
    <Field name={name}>
      {({ field, form, meta }: FieldProps<string>) => (
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            label={`${label} ${isRequired ? '*' : ''}`}
            defaultValue={moment(field.value)}
            onChange={(date) => handleDateChange(date, form)}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            slotProps={{
              textField: {
                fullWidth: true,
                // placeholder:placeholder,
                error: meta.touched && !!meta.error,
                helperText: meta.touched && meta.error ? errorMessage : '',
                onClick: () => setOpen(true),
              },
            }}
          />
        </LocalizationProvider>
      )}
    </Field>
  );
};

export default DateField;
